<template>
  <div class="tarea-gestion">
    <header class="header">
      <h1>Gestión de Tareas</h1>
    </header>
    <!-- Menú de navegación -->
    <nav class="menu">
      <button class="btn btn-secondary" @click="changeView('listar')">
        <font-awesome-icon icon="list" class="me-2" /> Listar Tareas
      </button>
      <button class="btn btn-primary" @click="changeView('crear')">
        <font-awesome-icon icon="plus" class="me-2" /> Crear Tarea
      </button>
    </nav>

    <!-- Renderizado dinámico de la vista según currentView -->
    <component 
      :is="currentViewComponent" 
      :taskId="taskIdToEdit"
      @change-view="changeView"
      @edit-task="handleEditTask"
      @cancel="changeView('listar')"
      @updated="changeView('listar')"
    />
  </div>
</template>

<script>
import TareaList from '@/components/LibretaTareas/TareaList.vue';
import TareaFormulario from '@/components/LibretaTareas/TareaFormulario.vue';
import TareaEditar from '@/components/LibretaTareas/TareaEditar.vue';

export default {
  name: 'TareaGestion',
  data() {
    return {
      currentView: 'listar',
      taskIdToEdit: null
    };
  },
  computed: {
    currentViewComponent() {
      switch (this.currentView) {
        case 'crear':
          return TareaFormulario;
        case 'editar':
          return TareaEditar;
        case 'listar':
        default:
          return TareaList;
      }
    }
  },
  methods: {
    changeView(view) {
      this.currentView = view;
    },
    handleEditTask(task) {
      this.taskIdToEdit = task.id;
      this.currentView = 'editar';
    }
  }
};
</script>

<style scoped>
.tarea-gestion {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.header {
  text-align: center;
  margin-bottom: 30px;
}
.header h1 {
  font-size: 2rem;
  margin: 0;
}
.menu {
  display: flex;
  justify-content: center;
  gap: 15px;
  flex-wrap: wrap;
  margin-bottom: 20px;
}
.btn {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 10px 20px;
  font-size: 1rem;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.2s ease, transform 0.2s ease;
}
.btn:hover {
  transform: scale(1.05);
}
.btn-primary {
  background-color: var(--app-primary);
  color: #fff;
}
.btn-primary:hover {
  background-color: var(--app-primary-dark);
}
.btn-secondary {
  background-color: #6c757d;
  color: #fff;
}
.btn-secondary:hover {
  background-color: #5a6268;
}
.btn-info {
  background-color: #17a2b8;
  color: #fff;
}
.btn-info:hover {
  background-color: #138496;
}
.me-2 {
  margin-right: 0.5rem;
}
@media (max-width: 768px) {
  .menu {
    flex-direction: column;
    align-items: center;
  }
  .btn {
    width: 100%;
    justify-content: center;
  }
}
</style>
